import React from 'react'
import { createStyles, withStyles } from '@material-ui/core'

import { expandNavBreakpoint } from '../../styles'
import BasePageLinkItem from '../../PageLinkItem'
import { links } from '../../../../constants/links'
import Programmes from './Programmes'

const styles = (theme) => {
  return createStyles({
    list: {
      paddingLeft: 0,
      [theme.breakpoints.up(expandNavBreakpoint)]: {
        display: 'flex',
        alignItems: 'center',
      },
    },
  })
}

const Links = ({ classes, hideMenu }) => {
  const Item = (props) => <BasePageLinkItem {...props} onClick={hideMenu} />
  return (
    <ul className={classes.list}>
      <Item to="/">Home</Item>
      <Programmes hideMenu={hideMenu} />
      <Item to={links.about}>About Us</Item>
      <Item to={links.onlineTuition}>Online Tuition</Item>
      <Item to={links.contact}>Contact </Item>
    </ul>
  )
}

export default withStyles(styles)(Links)
